import React, { useCallback } from "react";
import CSSTransition from "react-transition-group/CSSTransition";
import { TransitionProps } from "react-transition-group/Transition";
import { css } from "styled-components";

/**
 * NOTE: See if this can be used for existing fade transitions and look at
 * better re-using code between components.
 */

const FadeTransition = (props: Omit<TransitionProps, "addEndListener">) => {
    const addEndListener = useCallback((node: HTMLElement, done: () => void) => {
        node.addEventListener("transitionend", done);
    }, []);

    return (
        <CSSTransition
            classNames="fade"
            addEndListener={addEndListener}
            unmountOnExit
            {...props}
        />
    );
};

/**
 * Get CSS styles for fade transition.
 * @param duration Duration of transition in milliseconds (or CSS string).
 */
export function getFadeTransitionStyles(duration: number | string) {
    const formattedDuration = typeof duration === "number"
        ? `${duration}ms`
        : duration;

    return css`
        &.fade-appear,
        &.fade-enter {
            opacity: 0;
        }
        &.fade-appear-active,
        &.fade-enter-active,
        &.fade-appear-done,
        &.fade-enter-done {
            opacity: 1;
            transition: opacity;
            transition-duration: ${formattedDuration};
        }
        &.fade-exit {
            opacity: 1;
        }
        &.fade-exit-active,
        &.fade-exit-done {
            opacity: 0;
            transition: opacity;
            transition-duration: ${formattedDuration};
        }
    `;
}

export default FadeTransition;
